import { render, staticRenderFns } from "./EmployeeNotification.vue?vue&type=template&id=2fdaedfe"
import script from "./EmployeeNotification.vue?vue&type=script&lang=ts"
export * from "./EmployeeNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports